import { type ComputedRef, inject, type Ref } from 'vue'
import type { CombinedError, UseQueryState } from '@urql/vue'
import type { InitQuery } from '@/graphql/api'

import type { Benchmark } from '@/plugins/bench.ts'

export const initKey = 'app.plugin.init'

export interface InitPlugin {
    error: Ref<CombinedError | undefined>
    initQueryResponse: UseQueryState<InitQuery>
    showRegionModal: ComputedRef<boolean>
    isInitialized: Ref<boolean>
    promise: Promise<void>
    benchmark: Benchmark
}

export function useInit(): InitPlugin {
    return inject(initKey) as InitPlugin
}
